import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "ratingItem",
    "scoreDefinition",
    "ratingValue",
    "scaleRow",
    "completionPercent",
    "progressBar",
  ];

  connect() {
    this.calculateCompletion();
  }

  selectScaleItem(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const item = button.closest("[data-facilitator-preview-target='ratingItem']");
    if (!item) return;

    const buttons = item.querySelectorAll(".fa-scale-btn");
    const isSelected = button.classList.contains("fa-scale-btn--selected");

    buttons.forEach((btn) => {
      btn.classList.remove("fa-scale-btn--selected");
      btn.setAttribute("aria-pressed", "false");
    });

    if (!isSelected) {
      button.classList.add("fa-scale-btn--selected");
      button.setAttribute("aria-pressed", "true");
    }

    this.updateDescriptor(item, isSelected ? "" : button.dataset.description);
    this.calculateCompletion();
  }

  applyToAll(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const scaleItemId = button.dataset.scaleItemId;
    const value = button.dataset.value;
    const description = button.dataset.description || "";
    const ratingScaleId = button.dataset.ratingScaleId;

    if (!scaleItemId || !ratingScaleId) return;

    const items = this.ratingItemTargets.filter(
      (item) => item.dataset.ratingScaleId === ratingScaleId
    );

    items.forEach((item) => {
      const matchingButton = item.querySelector(
        `.fa-scale-btn[data-scale-item-id="${scaleItemId}"]`
      );
      if (!matchingButton) return;

      const buttons = item.querySelectorAll(".fa-scale-btn");
      buttons.forEach((btn) => {
        btn.classList.remove("fa-scale-btn--selected");
        btn.setAttribute("aria-pressed", "false");
      });

      matchingButton.classList.add("fa-scale-btn--selected");
      matchingButton.setAttribute("aria-pressed", "true");
      this.updateDescriptor(item, description);
    });

    this.calculateCompletion();
  }

  updateTextInput() {
    this.calculateCompletion();
  }

  updateDescriptor(item, text) {
    const definition = item.querySelector(
      "[data-facilitator-preview-target='scoreDefinition']"
    );
    if (definition) {
      definition.textContent = text || "";
    }
  }

  calculateCompletion() {
    const mandatoryItems = this.ratingItemTargets.filter(
      (item) => item.dataset.mandatory === "true"
    );

    if (mandatoryItems.length === 0) {
      this.setProgress(100);
      return;
    }

    let completed = 0;
    mandatoryItems.forEach((item) => {
      if (this.isItemComplete(item)) completed += 1;
    });

    const percent = Math.round((completed / mandatoryItems.length) * 100);
    this.setProgress(percent);
  }

  isItemComplete(item) {
    const selectedButton = item.querySelector(".fa-scale-btn--selected");
    if (selectedButton) return true;

    const singleText = item.querySelector("[data-text-key='single_text']");
    if (singleText && singleText.value.trim() !== "") return true;

    const valueInput = item.querySelector("[data-text-key='value']");
    if (valueInput && valueInput.value.trim() !== "") return true;

    const feedbackAreas = item.querySelectorAll(".fa-feedback-textarea");
    if (feedbackAreas.length > 0) {
      return Array.from(feedbackAreas).some(
        (area) => area.value.trim() !== ""
      );
    }

    return false;
  }

  setProgress(percent) {
    if (this.hasCompletionPercentTarget) {
      this.completionPercentTarget.textContent = `${percent}%`;
    }

    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${percent}%`;
      this.progressBarTarget.classList.toggle(
        "fa-progress-fill--complete",
        percent === 100
      );
    }
  }
}
